import React from 'react'
import { Placeholder } from '../../../Common'

export const PaginationPlaceholder = (_: any) => {
  return (
    <>
      <Placeholder
        width="3rem"
        style={{ height: '3rem', borderRadius: '50%' }}
      />
      <Placeholder width="6rem" className="mx-3" />
      <Placeholder
        width="3rem"
        style={{ height: '3rem', borderRadius: '50%' }}
      />
    </>
  )
}
